var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavAviation = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.4,10.5l-7.1-4.2V1.5c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v4.9l-7.1,4.2c-0.3,0.2-0.5,0.5-0.5,0.8 c0,0.6,0.6,1.1,1.2,0.9l6.4-1.9v4.9l-2,1.2c-0.1,0.1-0.2,0.2-0.2,0.4v0.5c0,0.3,0.3,0.5,0.6,0.4l2.6-0.6L9,17l0.3,0.1l0.4,0.1 l1.7,0.4l0.6,0.2c0.3,0.1,0.6-0.1,0.6-0.4v-0.5c0-0.2-0.1-0.3-0.2-0.4l-2-1.2v-4.9l6.4,1.9c0.6,0.2,1.2-0.3,1.2-0.9 C17.9,11,17.7,10.7,17.4,10.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavAviation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-aviation.41fde33ac804c19de93ff92665547ad4.svg";